import moment from "moment";

export const generateAccountingDates = (startDate, lastAccountingDate) => {
  let startYear = Number(startDate.substr(0, 4));
  let lastYear = Number(lastAccountingDate.substr(0, 4));

  let accountingConfigDate = lastYear - 4;
  if (lastYear - startYear <= 5) {
    accountingConfigDate = startYear;
  }

  // create an empty array:
  let accountingDateList = [];
  // loop between the two years:
  for (let i = lastYear; i >= accountingConfigDate; i--) {
    // add to array:
    accountingDateList.push({
      accountingDate: i + lastAccountingDate.substr(4),
      months: 12,
      year: i
    });
  }

  return accountingDateList;
};

export const recalculateAccountingMonths = (startDate, accountingDates) => {
  let accounting = adjustStartDateWithAccountingDates(
    startDate,
    accountingDates
  );

  let accountingDatesWithMonths = [];
  let iMax = accounting.length - 1;
  let startAccountingDateMonths = moment(
    accounting[iMax].accountingDate,
    "YYYY-MM-DD"
  ).diff(moment(startDate, "YYYY-MM-DD"), "months", true);

  for (let i = 0; i <= iMax; i++) {
    accountingDatesWithMonths.push({
      accountingDate: accounting[i].accountingDate,
      months:
        i === iMax && startAccountingDateMonths > 18
          ? 12
          : Math.round(
              moment(accounting[i].accountingDate, "YYYY-MM-DD").diff(
                moment(
                  i === iMax ? startDate : accounting[i + 1].accountingDate,
                  "YYYY-MM-DD"
                ),
                "months",
                true
              )
            ),
      year: i ? accountingDatesWithMonths[i - 1].year - 1 : accounting[i].year
    });
  }

  return accountingDatesWithMonths;
};

export const adjustStartDateWithAccountingDates = (
  startDate,
  accountingDates
) => {
  let adjustedAccountingDates = [...accountingDates];
  let iMax = accountingDates.length - 1;
  let startAccountingDateMonths = moment(
    accountingDates[iMax].accountingDate,
    "YYYY-MM-DD"
  ).diff(moment(startDate, "YYYY-MM-DD"), "months", true);

  if (startAccountingDateMonths <= 6) {
    adjustedAccountingDates = adjustedAccountingDates.splice(0, iMax);
    adjustedAccountingDates = adjustStartDateWithAccountingDates(
      startDate,
      adjustedAccountingDates
    );
  }

  return adjustedAccountingDates;
};

export const calculateEventualDiffMonths = (newerDate, earlierDate) => {
  return Math.round(
    moment(newerDate, "YYYY-MM-DD")
      .add(-1, "year")
      .diff(moment(earlierDate, "YYYY-MM-DD"), "months", true)
  );
};

export const compareAccountingDates = (accounting1, accounting2) => {
  if (accounting1.length !== accounting2.length) {
    return false;
  }
  for (let i = 0; i < accounting1.length; i++) {
    if (
      accounting1[i].accountingDate !== accounting2[i].accountingDate ||
      accounting1[i].months !== accounting2[i].months
    ) {
      return false;
    }
  }
  return true;
};

export const number_format = (number, decimals, dec_point, thousands_sep) => {
  // http://kevin.vanzonneveld.net
  // +   original by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
  // +   improved by: Kevin van Zonneveld (http://kevin.vanzonneveld.net)
  // +     bugfix by: Michael White (http://getsprink.com)
  // +     bugfix by: Benjamin Lupton
  // +     bugfix by: Allan Jensen (http://www.winternet.no)
  // +    revised by: Jonas Raoni Soares Silva (http://www.jsfromhell.com)
  // +     bugfix by: Howard Yeend
  // +    revised by: Luke Smith (http://lucassmith.name)
  // +     bugfix by: Diogo Resende
  // +     bugfix by: Rival
  // +      input by: Kheang Hok Chin (http://www.distantia.ca/)
  // +   improved by: davook
  // +   improved by: Brett Zamir (http://brett-zamir.me)
  // +      input by: Jay Klehr
  // +   improved by: Brett Zamir (http://brett-zamir.me)
  // +      input by: Amir Habibi (http://www.residence-mixte.com/)
  // +     bugfix by: Brett Zamir (http://brett-zamir.me)
  // +   improved by: Theriault
  // +   improved by: Drew Noakes
  // *     example 1: number_format(1234.56);
  // *     returns 1: '1,235'
  // *     example 2: number_format(1234.56, 2, ',', ' ');
  // *     returns 2: '1 234,56'
  // *     example 3: number_format(1234.5678, 2, '.', '');
  // *     returns 3: '1234.57'
  // *     example 4: number_format(67, 2, ',', '.');
  // *     returns 4: '67,00'
  // *     example 5: number_format(1000);
  // *     returns 5: '1,000'
  // *     example 6: number_format(67.311, 2);
  // *     returns 6: '67.31'
  // *     example 7: number_format(1000.55, 1);
  // *     returns 7: '1,000.6'
  // *     example 8: number_format(67000, 5, ',', '.');
  // *     returns 8: '67.000,00000'
  // *     example 9: number_format(0.9, 0);
  // *     returns 9: '1'
  // *    example 10: number_format('1.20', 2);
  // *    returns 10: '1.20'
  // *    example 11: number_format('1.20', 4);
  // *    returns 11: '1.2000'
  // *    example 12: number_format('1.2000', 3);
  // *    returns 12: '1.200'
  var n = !isFinite(+number) ? 0 : +number,
    prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
    sep = typeof thousands_sep === "undefined" ? "," : thousands_sep,
    dec = typeof dec_point === "undefined" ? "." : dec_point,
    toFixedFix = function(n, prec) {
      // Fix for IE parseFloat(0.55).toFixed(0) = 0;
      var k = Math.pow(10, prec);
      return Math.round(n * k) / k;
    },
    s = (prec ? toFixedFix(n, prec) : Math.round(n)).toString().split(".");
  if (s[0].length > 3) {
    s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
  }
  if ((s[1] || "").length < prec) {
    s[1] = s[1] || "";
    s[1] += new Array(prec - s[1].length + 1).join("0");
  }
  return s.join(dec);
};



// WEBPACK FOOTER //
// ./src/utils/balance.js